// src/components/pages/Pessoa/helpers/resolveColaboradorSections.js
export function resolveColaboradorSections({ ramoAtividade } = {}) {
    // Tenta limpar aspas extras se vierem do JSON.stringify e remove espaços
    const ramo = String(ramoAtividade || '')
        .replace(/^["']|["']$/g, '') // Remove aspas no início e no fim
        .trim();

    return {
        showAdministrativo: true,
        showManutencao: true,
        showDashboards: true,
        showIndustria: ramo === 'Industria',
        showPadaria: ramo === 'Padaria',
    };
}
